function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Triangle(props) {
  const {
    width,
    height,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 15",
    width: width,
    height: height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M15.463 1.2L8.5 12.685 1.537 1.2h13.925zM1.353.896s0 0 0 0h0z",
    stroke: "#DD1367",
    strokeWidth: 2.4
  }));
}

export default Triangle;